import type {
  ProductSearchPage,
  ProductSearchParams,
  SearchSuggestion,
  SearchSuggestions,
} from '@maestro/data-layer'

import { apiGet } from '@maestro/core/api-client'

export function getSearchSuggestions(
  text?: string
): Promise<SearchSuggestions<SearchSuggestion>> {
  return apiGet<SearchSuggestions<SearchSuggestion>>(
    '/api/search/suggestions',
    { text }
  )
}

export function searchProducts(
  text: string,
  params?: ProductSearchParams
): Promise<ProductSearchPage> {
  return apiGet<ProductSearchPage>('/api/search/products', {
    text,
    resultsPerPage: params?.resultsPerPage?.toString(),
    filters: params?.filters,
  })
}
